import { useRef } from "react";
import InputField from "../../UI/Inputs/InputField";
import Button from "../../UI/Button";
import { SignPropsType } from "../../../pages/Sign/utils";
import style from "../../../pages/Sign/index.module.css";
import { useTranslation } from "../../../hooks/useTranslation";

const Signup = ({ register, watch, errors, isSubmitting, isSocialRegister }: SignPropsType) => {
  // TODO: check why do we need password in ref
  const password = useRef({});
  password.current = watch?.("signup_password");
  const { locale } = useTranslation();

  return (
    <>
      <InputField
        label={locale("name")}
        placeholder={locale("name")}
        type="text"
        extraProps={{
          ...register("signup_name", { required: true }),
          disabled: isSocialRegister,
        }}
        error={errors?.signup_name ? locale("required_field") : ""}
      />
      {/* <InputField
        label={translation[siteLang].email}
        placeholder={translation[siteLang].email}
        type="text"
        extraProps={{
          ...register("signup_email", { required: true }),
          disabled: isSocialRegister,
        }}
        error={errors?.signup_email ? translation[siteLang].required_field : ""}
      /> */}
      <InputField
        label={locale("phone")}
        placeholder={locale("phone")}
        type="phone"
        extraProps={register("signup_phone", { required: true })}
        error={errors?.signup_phone ? locale("required_field") : ""}
      />
      {!isSocialRegister && (
        <>
          <InputField
            label={locale("password")}
            placeholder={locale("password")}
            type="password"
            extraProps={register("signup_password", { required: true })}
            error={errors?.signup_password ? locale("required_field") : ""}
          />
          <InputField
            label={locale("confirm_password")}
            placeholder={locale("confirm_password")}
            type="password"
            extraProps={register("signup_confirm_password", {
              validate: (value) => value === password.current || locale("passwords_dont_match"),
            })}
            error={errors?.signup_confirm_password ? errors.signup_confirm_password.message : ""}
          />
        </>
      )}
      <div className={style.form_ctas}>
        <Button disabled={isSubmitting} isLoading={isSubmitting} styleType="primary_black" buttonType="submit">
          {locale("signup")}
        </Button>
      </div>
    </>
  );
};

export default Signup;
